import { rankList } from '@/mocks/dramas';
import { useState } from 'react';

export default function Ranking() {
  const [tab, setTab] = useState<'总榜' | '周榜'>('总榜');

  return (
    <section id="rank" className="scroll-mt-20 bg-[#f3ecdf]/50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#e85d3f]">大家都在追什么</p>
            <h2 className="font-serif-sc text-2xl font-black text-[#26201a] md:text-3xl">热播连续剧榜单</h2>
          </div>

          <div className="flex w-fit rounded-full border border-[#26201a]/10 bg-white p-1">
            {(['总榜', '周榜'] as const).map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${
                  tab === t ? 'bg-[#26201a] text-white' : 'text-[#6f655a] hover:text-[#26201a]'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-2.5">
          {rankList.map((r) => (
            <a
              key={r.rank}
              href="#news"
              className="group flex items-center gap-4 rounded-2xl border border-[#26201a]/8 bg-white p-3 transition-colors hover:border-[#e85d3f]/40 hover:bg-white"
            >
              <span
                className={`font-serif-sc flex h-10 w-8 shrink-0 items-center justify-center text-xl font-black ${
                  r.rank === 1 ? 'text-[#e85d3f]' : r.rank === 2 ? 'text-[#8a6d3b]' : 'text-[#a3988a]'
                }`}
              >
                {r.rank}
              </span>
              <div className="hidden h-14 w-11 shrink-0 overflow-hidden rounded-lg sm:block">
                <img src={r.img} alt={r.title} className="h-full w-full object-cover" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-sm font-bold text-[#26201a] group-hover:text-[#e85d3f]">{r.title}</h3>
                  <span className="rounded-md bg-[#f3ecdf] px-1.5 py-0.5 text-[10px] font-medium text-[#8a6d3b]">{r.genre}</span>
                </div>
                <div className="mt-1 flex items-center gap-3 text-[11px] text-[#a3988a]">
                  <span>
                    <i className="ri-fire-line text-[#e85d3f]"></i> {r.heat}
                  </span>
                  <span className="flex items-center gap-1">
                    {r.trend === 'up' && <i className="ri-arrow-up-line text-[#3e7c59]"></i>}
                    {r.trend === 'down' && <i className="ri-arrow-down-line text-[#a3988a]"></i>}
                    {r.trend === 'flat' && <i className="ri-arrow-right-line text-[#a3988a]"></i>}
                    热度{tabs[r.trend]}
                  </span>
                </div>
              </div>
              <span className="hidden shrink-0 items-center gap-1 text-xs font-semibold text-[#e85d3f] sm:flex">
                看速递 <i className="ri-arrow-right-s-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

const tabs = { up: '上升', down: '回落', flat: '持平' } as const;